export default function removeDeletedTaskTemplates(shift) {
  if (shift.taskTemplates) {
    return {
      ...shift,
      taskTemplates: shift.taskTemplates.filter(({ deleted }) => !deleted),
    };
  }
  return shift;
}
